var map = {
	"./AddStatus.png": 14972,
	"./Alert.png": 29873,
	"./Approve white.png": 13727,
	"./Approved green.png": 87276,
	"./ApprovedRight.png": 88418,
	"./ArrowRight.png": 9640,
	"./Arrow_right_grey.png": 33185,
	"./Awaiting_Verification.png": 87951,
	"./BeneTxn_ArrowLeft.png": 84800,
	"./Close-icon.png": 26637,
	"./Close.png": 68399,
	"./Components.png": 16087,
	"./Decline white.png": 34506,
	"./Declined red.png": 83300,
	"./DeclinedRed_Img.png": 46728,
	"./DeclinedTxn.png": 46611,
	"./DeclinedTxn_red.png": 56879,
	"./EqualButton.png": 92127,
	"./ErrorPage.png": 39356,
	"./Failed screen.png": 77570,
	"./InitialEmail.png": 45959,
	"./MultiApprovalTxnBlue.png": 26795,
	"./MultiView.png": 69027,
	"./MultiViewTxn.png": 45433,
	"./Next.png": 47200,
	"./Pending yellow.png": 41732,
	"./Previous.png": 82396,
	"./Primary.png": 82609,
	"./Queued.png": 93248,
	"./RefreshBalance.png": 63792,
	"./Reload white.png": 48315,
	"./SelectWhite.png": 50652,
	"./SendPaymentAdvice.png": 82843,
	"./Settle.png": 82694,
	"./SingleApprovalTxn.png": 66102,
	"./Success screen.png": 50284,
	"./Task switcher.png": 18807,
	"./Vendor.png": 39457,
	"./Verified.png": 46807,
	"./WhiteArrow_right.png": 33206,
	"./WhiteDashboard.png": 7026,
	"./WhiteLoaderImages.png": 69191,
	"./arrowUp.png": 76343,
	"./filter.png": 74565,
	"./not selected.png": 28093,
	"./search-white.png": 41695,
	"./select all.png": 36586,
	"./selected.png": 49408,
	"./unknown.png": 69669,
	"./white_AwaitingVerification.png": 83426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37608;